import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-triangle-right",
  "use": "icon-icon-triangle-right-usage",
  "viewBox": "0 0 6.047 8",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 6.047 8\" id=\"icon-icon-triangle-right\">\n  <path id=\"icon-icon-triangle-right_Path_1098\" data-name=\"Path 1098\" d=\"M4,0,0,6.047H8Z\" transform=\"translate(6.047) rotate(90)\" fill=\"#3f45d1\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol